import classNames from "classnames";
import { CSSProperties, ReactNode } from "react";
import useElementOnScreen from "../../../../../hooks/useElementOnScreen";
import MarkdownRenderer from "../../../../common/MarkdownRenderer/MarkdownRenderer";
import phonesDominoMobile from "../../../../imagenes/home/domino_cropped_white.webp";
import phonesDominoDesktop from "../../../../imagenes/home/improved_domino_350KB.webp";
import smartWatch from "../../../../imagenes/home/smart-watch.png";
import mockMessages from "../../../../imagenes/home/web_mock_1-portrait_1.png";
import mockTakeaways from "../../../../imagenes/home/web_mock_2-portrait_2.png";
import mockView from "../../../../imagenes/home/web_mock_3-portrait_1.png";
import Picture from "../../../../ui/Picture/Picture";
import "./Solution.scss";

type InsightItem = {
	text: string;
	img: string;
};

export type SolutionContent = {
	enabled: boolean;
	title: string;
	imgMiddle: string;
	subtitle: string;
	content: string;
	insights: InsightItem[];
	notes: string;
	category: string;
};

const mockImagesMap = {
	"web_mock-view": mockView,
	"web_mock-messages": mockMessages,
	"web_mock-takeaways": mockTakeaways,
};

const StepsOffsetList = ({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) => <ul className={classNames("list list--step", className)}>{children}</ul>;

const StepItem = ({
	children,
	className,
	style,
}: {
	children: ReactNode;
	className?: string;
	style?: CSSProperties;
}) => {
	const [containerRef, isVisible] = useElementOnScreen<Element>({
		rootMargin: "0px 0px 1000px 0px",
	});
	const hasFadeInFromDirection = /fade-in--from-[^\s]+/.test(className || "");

	return (
		<li
			className={classNames(
				"list__item list__item--step skip-animation fade-in fade-in--from-left",
				className,
				{
					"fade-in--from-left": !hasFadeInFromDirection,
					visible: isVisible,
				},
			)}
			style={style}
			ref={containerRef as any}>
			{children}
		</li>
	);
};

const Solution = ({ sectionContent }: { sectionContent: SolutionContent }) => {
	return (
		<section className="solution">
			<div className="content-container">
				<img
					src={smartWatch}
					className="resize-img smart-watch"
					alt=""
					width="420"
					height="420"
					style={
						{
							"--width-desktop": "559px",
							"--height-desktop": "559px",
						} as CSSProperties
					}
				/>
				<MarkdownRenderer>{sectionContent.title}</MarkdownRenderer>
			</div>
			<div className="background-container--full-width skip-animation">
				<Picture
					media="(min-width: 768px)"
					className="phones-domino"
					mobileSrc={phonesDominoMobile}
					desktopSrc={phonesDominoDesktop}
				/>
			</div>
			<div className="background-container--full-width background-container--gradient">
				<div className="content-container">
					<MarkdownRenderer>{sectionContent.subtitle}</MarkdownRenderer>
					<MarkdownRenderer>{sectionContent.content}</MarkdownRenderer>
					<StepsOffsetList>
						{sectionContent.insights.map((item, index) => (
							<StepItem key={index}>
								<MarkdownRenderer>{item.text}</MarkdownRenderer>
								<div className="list__item--step-img-container skip-animation">
									<img
										src={mockImagesMap[item.img as keyof typeof mockImagesMap]}
										className="resize-img mock"
										alt=""
										width="240"
										height="auto"
										style={
											{
												"--width-desktop": "320px",
											} as CSSProperties
										}
									/>
								</div>
							</StepItem>
						))}
					</StepsOffsetList>
					<MarkdownRenderer>{sectionContent.notes}</MarkdownRenderer>
					<div className="keep-color">
						<MarkdownRenderer>{sectionContent.category}</MarkdownRenderer>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Solution;
